// extracted by mini-css-extract-plugin
export default {"iframe":"PrintableIframe_iframe__LPBmH"};